import {
  THREAT_PREVENTION_PROFILES_GET_REQUEST,
  THREAT_PREVENTION_PROFILES_GET_REQUEST_FAILURE,
  THREAT_PREVENTION_PROFILES_GET_REQUEST_SUCCESS,
} from "./consts";
import { ThreatPreventionProfilesGetActionTypes } from "./threatPreventionProfilesGetActions";

// ------------------------------------
// State
// ------------------------------------
export interface ThreatPreventionProfilesGetState {
  loading: boolean;
  loaded: boolean;
  error: any;
  data: any;
}

const initialState: ThreatPreventionProfilesGetState = {
  loading: false,
  loaded: false,
  error: null,
  data: null,
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function threatPreventionProfilesGetReducer(
  state = initialState,
  action: ThreatPreventionProfilesGetActionTypes
): ThreatPreventionProfilesGetState {
  switch (action.type) {
    case THREAT_PREVENTION_PROFILES_GET_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case THREAT_PREVENTION_PROFILES_GET_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data,
        error: null,
      };
    case THREAT_PREVENTION_PROFILES_GET_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
}
